export default __webpack_public_path__ + "static/media/hom2.3f6c33d5.png";